import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminCtrlVehGeocerca } from 'src/app/models/admin-ctrlvehiculo-geocerca';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ControlGeocercaService } from 'src/app/services/flota/control-geocerca-service/control-geocerca.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';

import { interval } from 'rxjs';

@Component({
  selector: 'app-control-vehiculos-sintransmitir',
  templateUrl: './control-vehiculos-sintransmitir.component.html',
  styleUrls: ['./control-vehiculos-sintransmitir.component.scss']
})
export class ControlVehiculosSinTransmitir implements OnInit {
  
  loading:boolean = false;
  public contClass: string = 'container-fluid maincont';
  public perfilData = {
    minreporte: null,
    activar: false,
    intervalonotif: null,
  };

  constructor(
    public gtp: Gtp,
    private ctrlVehiculo: ControlVehiculosService,
  ) {
          
  }
  
  ngOnInit(): void {
    if (this.ctrlVehiculo.SinTransmitirConfig) {
      this.setInitialInfo();
    } 
  }

  setInitialInfo(){
    this.perfilData.intervalonotif = this.ctrlVehiculo.SinTransmitirConfig.intervalonotif;
    this.perfilData.minreporte = this.ctrlVehiculo.SinTransmitirConfig.minreporte;
    this.perfilData.activar = this.ctrlVehiculo.SinTransmitirConfig.activar;
  }
  
  saveParams(){
    this.perfilData = JSON.parse(JSON.stringify(this.perfilData));
    this.ctrlVehiculo.setSinTransmitirConfig(this.perfilData);    
    console.log('Actualizando...');
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

}
